'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _reactRouter = require('react-router');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _analyticsEventComposers = require('@bibliocommons/analytics-event-composers');

var _utilsAnalytics = require('@bibliocommons/utils-analytics');

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var composeAuthorClickEvent = _analyticsEventComposers.bibEventComposer.composeAuthorClickEvent;
var CUSTOM_DIMENSIONS = _constantsAnalytics2.default.CUSTOM_DIMENSIONS;

var AuthorLink = function (_BcReactComponent) {
  _inherits(AuthorLink, _BcReactComponent);

  function AuthorLink(props) {
    _classCallCheck(this, AuthorLink);

    var _this = _possibleConstructorReturn(this, (AuthorLink.__proto__ || Object.getPrototypeOf(AuthorLink)).call(this, props));

    _this.bindAll('handleClick');
    return _this;
  }

  _createClass(AuthorLink, [{
    key: 'handleClick',
    value: function handleClick() {
      var reciprocalRank = this.props.reciprocalRank;

      (0, _utilsAnalytics.sendAnalyticsEvents)(composeAuthorClickEvent({ containerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ITEM, reciprocalRank: reciprocalRank }));
    }
  }, {
    key: 'renderAuthorLink',
    value: function renderAuthorLink(author) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _props = this.props,
          target = _props.target,
          renderAsLink = _props.renderAsLink;


      if (renderAsLink) {
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            key: index,
            onClick: this.handleClick,
            className: 'author-link',
            activeClassName: 'active-search-link',
            target: target,
            rel: 'noopener noreferrer',
            to: { pathname: '/v2/search', query: { query: author, searchType: 'author' } } },
          author
        );
      }

      return _react2.default.createElement(
        'div',
        { key: index, className: 'author-link' },
        author
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var authors = this.props.authors;

      var normalizedAuthors = Array.isArray(authors) ? authors : authors.toJS();

      if (normalizedAuthors.length) {
        if (normalizedAuthors.length >= 1) {
          var links = normalizedAuthors.map(function (author, i) {
            return _react2.default.createElement(
              'span',
              { key: author + '-' + i },
              _this2.renderAuthorLink(author, i),
              i < normalizedAuthors.length - 1 ? ' • ' : ''
            );
          });

          return _react2.default.createElement(
            'span',
            { className: 'author-link-list' },
            links
          );
        }

        return _react2.default.createElement(
          'span',
          { className: 'author-link-list' },
          this.renderAuthorLink(normalizedAuthors[0])
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }]);

  return AuthorLink;
}(_baseBcReactComponent2.default);

exports.default = AuthorLink;


AuthorLink.propTypes = {
  authors: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.string), _reactImmutableProptypes2.default.listOf(_react.PropTypes.string)]),
  target: _react.PropTypes.string,
  renderAsLink: _react.PropTypes.bool,
  reciprocalRank: _react.PropTypes.number
};

AuthorLink.defaultProps = {
  authors: [],
  target: '_parent',
  renderAsLink: true
};

AuthorLink.displayName = 'AuthorLink';


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-author-link/lib/components/AuthorLink.component.js
// module id = 1175
// module chunks = 0